import { createContext, useContext, useState } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

const detectInitialLang = () => {
  if (typeof navigator === "undefined") return "pt";
  const browserLang = (navigator.language || navigator.languages?.[0] || "").toLowerCase();
  if (browserLang.startsWith("en")) return "en";
  return "pt";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(detectInitialLang);
  const value = { lang, setLang, t: translations[lang] };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
